import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { setPageSeo } from "../lib/seo";
import { BUSINESS } from "../lib/business";

export default function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
    setPageSeo({
      title: "Terms & Conditions — DevzCorner",
      description:
        "Terms and conditions for DevzCorner software, AI, hardware, and product development services.",
      path: "/terms",
    });
  }, []);

  return (
    <main className="relative bg-ink-0 text-white min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-grow pt-32 pb-24 px-6 md:px-10 max-w-4xl mx-auto w-full">
        <h1 className="font-display text-4xl md:text-5xl mb-8">Terms &amp; Conditions</h1>
        <div className="prose prose-invert max-w-none text-zinc-400 font-light leading-relaxed space-y-6">
          <p>Last updated: October 2026</p>
          <p>
            Please read these Terms &amp; Conditions carefully before using the {BUSINESS.legalName} website
            or engaging our services. By accessing our site or paying for services, you agree to these Terms.
          </p>

          <h2 className="text-white text-2xl font-display mt-8 mb-4">1. Acceptance of Terms</h2>
          <p>
            By accessing or using our services, you agree to be bound by these Terms. If you disagree with any part of the terms, you may not access the service or make a purchase.
          </p>

          <h2 className="text-white text-2xl font-display mt-8 mb-4">2. Business Identity</h2>
          <p>
            Services are provided by <strong className="text-white">{BUSINESS.legalName}</strong>, operating from{" "}
            {BUSINESS.addressOneLine}. Contact:{" "}
            <a href={`mailto:${BUSINESS.email}`} className="text-white underline hover:text-zinc-300 transition-colors">
              {BUSINESS.email}
            </a>
            ,{" "}
            <a href={BUSINESS.phoneHref} className="text-white underline hover:text-zinc-300 transition-colors">
              {BUSINESS.phoneDisplay}
            </a>
            .
          </p>

          <h2 className="text-white text-2xl font-display mt-8 mb-4">3. Services &amp; Pricing</h2>
          <p>
            {BUSINESS.legalName} provides software development, AI product engineering, hardware/IoT, 3D fabrication, and consulting. Public starting prices are listed on our{" "}
            <a href="/#pricing" className="text-white underline hover:text-zinc-300 transition-colors">
              Pricing
            </a>{" "}
            section. Final fees, scope, deliverables, and timeline for each paid engagement are set out in a Statement of Work (SOW) or project agreement before payment. Taxes (including GST) may apply as required by law.
          </p>

          <h2 className="text-white text-2xl font-display mt-8 mb-4">4. Payments</h2>
          <p>
            Payments may be collected via third-party payment gateways. Card and bank details are processed by those providers; we do not store full payment-card data on our website. Refunds and cancellations follow our{" "}
            <a href="/refund" className="text-white underline hover:text-zinc-300 transition-colors">
              Refund &amp; Cancellation Policy
            </a>
            .
          </p>

          <h2 className="text-white text-2xl font-display mt-8 mb-4">5. Intellectual Property</h2>
          <p>
            Unless otherwise agreed in writing, {BUSINESS.legalName} retains intellectual property rights to pre-existing materials, tools, or methodologies. Client-specific deliverables transfer to the client upon full payment as stipulated in the individual agreement.
          </p>

          <h2 className="text-white text-2xl font-display mt-8 mb-4">6. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, {BUSINESS.legalName} shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the services.
          </p>

          <h2 className="text-white text-2xl font-display mt-8 mb-4">7. Governing Law</h2>
          <p>
            These Terms shall be governed by the laws of India, with courts in <strong className="text-white">Bengaluru, Karnataka</strong> having jurisdiction, without regard to conflict-of-law provisions.
          </p>

          <h2 className="text-white text-2xl font-display mt-8 mb-4">8. Changes to Terms</h2>
          <p>
            We may update these Terms at any time. Changes will be posted on this page with an updated date. Continued use of our services after changes constitutes acceptance of the new Terms.
          </p>

          <h2 className="text-white text-2xl font-display mt-8 mb-4">9. Contact Us</h2>
          <p>
            {BUSINESS.legalName}<br />
            {BUSINESS.addressOneLine}<br />
            Phone:{" "}
            <a href={BUSINESS.phoneHref} className="text-white underline hover:text-zinc-300 transition-colors">
              {BUSINESS.phoneDisplay}
            </a>
            <br />
            Email:{" "}
            <a href={`mailto:${BUSINESS.email}`} className="text-white underline hover:text-zinc-300 transition-colors">
              {BUSINESS.email}
            </a>
          </p>
        </div>
      </div>
      <Footer />
    </main>
  );
}
